import React, { VFC } from 'react'
import { Answer } from 'enums'
import useAnalysis from 'hooks/useAnalysis'
import { addClassName } from 'utils'

type Props = {
  className?: string
  index: number
  done?: boolean
}

const YesButton: VFC<Props> = (props) => {
  const { moveToNextQuestion, showResult } = useAnalysis()
  const done = props.done || false

  return (
    <button
      className={`border-2 btn-1 border-custom-5 text-custom-5 sm:border-[3px] lg:max-w-[258px] lg:border-2 lg:duration-300 lg:hover:bg-custom-5 lg:hover:text-white ${addClassName(
        props.className
      )}`}
      onClick={
        !done
          ? () => moveToNextQuestion(Answer.YES, props.index)
          : () => showResult(props.index)
      }
    >
      YES
    </button>
  )
}

export default YesButton
